import PropTypes from 'prop-types';
import {connect} from '~/redux/connect';
import React, {Component} from 'react';
import CenterWrapper from "~/components/CenterWrapper/CenterWrapper";
// import {Area} from "~/ui/Style";
import getConfig from "~/config";
import css from './css.css';
import isArray from 'lodash/isArray';
import MessageList from '../../components/MessageList/MessageList';
import { Area, Box, H1, List, ScrollView, VStack, } from '~/native-ui';

class ErrorPage extends Component {
    static propTypes = {};

    renderErrorInfo = () => {
        let { trans, state, error } = this.props;

        return (
            <VStack space={ 4 }>
                {error && <Area>
                    <H1>Error</H1>
                    <ScrollView horizontal>
                        <Box className={css.pre}>{JSON.stringify(error)}</Box>
                    </ScrollView>
                </Area>}
                <Area>
                    <H1>Application State</H1>
                    <ScrollView horizontal>
                        <Box className={css.pre}>{JSON.stringify(state)}</Box>
                    </ScrollView>
                </Area>
            </VStack>
        )
    };

    renderErrorMessageList = () => {
        let { error } = this.props;
        return <Area><MessageList messages={ error.error } /></Area>
    }

    renderErrorMessage = () => {
        let { trans } = this.props;
        let supportNumber = getConfig().supportNumber;

        return (
            <>
                <Area>
                    <H1 fontSize="4xl">{trans('errorPage.title')}</H1>
                    <Box>{trans('errorPage.sorry', {supportNumber})}</Box>
                </Area>
                <Area>
                    <H1>{trans('errorPage.hintTitle')}</H1>
                    <List.Unordered>
                        <List.Item>{trans('errorPage.hint1')}</List.Item>
                        <List.Item>{trans('errorPage.hint2')}</List.Item>
                        <List.Item>{trans('errorPage.hint3')}</List.Item>
                        <List.Item>{trans('errorPage.hint4')}</List.Item>
                    </List.Unordered>
                </Area>

                {this.renderErrorInfo()}
            </>
        )
    }

    render() {
        let { error } = this.props;
        return (
            <CenterWrapper>
                {
                    error && isArray(error.error)
                    ? this.renderErrorMessageList()
                    : this.renderErrorMessage()
                }
            </CenterWrapper>
        );
    }
}

const RXErrorPage = connect((state) => ({state}))(ErrorPage);

export default RXErrorPage;